import {
  GetCommitmentReportResponseSchema,
  type GetCommitmentReportResponsePayload,
} from '@vy/api-definition';
import { validateNotNullOrUndefined, withDefault } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useCommitmentReport(
  reportId?: string,
  options?: CustomUseQueryOptions<GetCommitmentReportResponsePayload>,
) {
  const reportIdentifier = withDefault(reportId, '');
  const getCommitmentReportQuery = useQuery(
    queryKeys.commitmentReport(reportIdentifier),
    async () => {
      const api = getPrivateApi();
      const getCommitmentReportResponse = await api.getCommitmentReport({
        reportId,
      });

      return GetCommitmentReportResponseSchema.parse(getCommitmentReportResponse);
    },
    {
      suspense: true,
      ...options,
    },
  );

  validateNotNullOrUndefined(getCommitmentReportQuery.data, 'getCommitmentReportQuery data');

  return getCommitmentReportQuery;
}
